//PCIB登录模板
<template>
  <div id="pcib_login" v-loading="loading" element-loading-text="验证中...">
    <div class="login_form">
      <div class="form-title">订单客户授权登录</div>
      <ul>
        <!-- <li>订单客户授权登录</li> -->
        <li class="input_area">
          <span>订单编号：</span>
          <input type="text" v-model="user" @keyup.enter="signIn()" />
        </li>
        <li class="input_area">
          <span>密码：</span>
          <input type="password" v-model="pwd" @keyup.enter="signIn()" />
        </li>
        <li class="sign_in">
          <button @click="signIn()" :disabled="user === '' || pwd === ''">
            登 录
          </button>
          <!-- <span>
            <router-link :to="{ name: 'pcibOrderForget'}">忘记密码</router-link>
          </span> -->
        </li>
        <li class="forgot-pass">
            <router-link :to="{ name: 'pcibOrderForget'}">忘记密码</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { post } from "@/util/http";
export default {
  name: "pcibOrderLogin",

  watch: {},
  data() {
    let input_str = this.$route.query.order_number;
    return {
      user: input_str,
      pwd: "",
      loading: false
    };
  },
  beforeCreate() {
    let self = this;
    let token = sessionStorage.getItem("authToken");
    let user = JSON.parse(sessionStorage.getItem("user"));
    let localToken = localStorage.getItem("authToken");
    if (token && localToken) {
      if (user && user.is_pcib_account && !user.is_superuser) {
        self.$router.push({
          name: "pcibOrderHome"
        });
      } else if (user && user.is_pcib_account && user.is_superuser) {
        self.$router.push({
          name: "pcibOrderImport"
        });
      }
    }
  },

  mounted() {
    if (
      navigator.appName == "Microsoft Internet Explorer" &&
      parseInt(
        navigator.appVersion
          .split(";")[1]
          .replace(/[ ]/g, "")
          .replace("MSIE", "")
      ) == 9
    ) {
      window.alert(
        "您当前使用的是IE9版本，会导致部分功能无法使用，请使用IE10及以上版本"
      );
    }
  },
  methods: {
    signIn() {
      let self = this;
      sessionStorage.removeItem("authToken");
      sessionStorage.removeItem("user");
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
      if (self.user.trim() === "" || self.pwd.trim() === "") {
        return false;
      }
      self.loading = true;
      post("user/pciblogin/", {
        crm_order_no: self.user,
        password: self.pwd
      }).then(
        res => {
          self.loading = false;
          if (res.user.is_pcib_account && res.user.is_superuser) {
            sessionStorage.setItem("authToken", res.token);
            sessionStorage.setItem("user", JSON.stringify(res.user));
            localStorage.setItem("authToken", res.token);
            localStorage.setItem("user", JSON.stringify(res.user));
            self.$router.push({
              name: "pcibOrderImport"
            });
          } else if (res.user.is_pcib_account && !res.user.is_superuser) {
            sessionStorage.setItem("authToken", res.token);
            sessionStorage.setItem("user", JSON.stringify(res.user));
            localStorage.setItem("authToken", res.token);
            localStorage.setItem("user", JSON.stringify(res.user));
            self.$router.push({
              name: "pcibOrderHome"
            });
          } else {
            self.$notify({
              type: "error",
              message: "该账户未授权！",
              offset: 70,
              duration: 2000
            });
          }
        },
        err => {
          self.loading = false;
          self.$notify({
            type: "error",
            message: "用户名或者密码错误！",
            offset: 70,
            duration: 2000
          });
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mirrors/auths/PcibOrderLogin.vue